// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".actions[data-v-773a2ada] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit[data-v-773a2ada] {\n  margin-left: 1px;\n}\n.remove[data-v-773a2ada] {\n  margin-top: -2px;\n  margin-left: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
